// src/Catering/Beverages.jsx
import React from "react";
import { CateringCategoryContent } from "./CateringLayout";


const Beverages = () => {
    return (
        <CateringCategoryContent
            categoryId="6658fc5fcdd47868117abce0"
            titleOverride="Beverages"
        />
    );
};

export default Beverages;